import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListLoginTimeoutResponse } from '../../responses/user/list-login-timeout.reponse';

@Injectable({
  providedIn: 'root'
})
export class LoginTimeoutService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listLoginTimeout(): Observable<ListLoginTimeoutResponse> {

    let uri = 'LoginTimeout/getAll'

    return this.httpClient.get<ListLoginTimeoutResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiUser) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  } 
}
